/*
  The families a file can belong to. Held apart from `attachment-badge-util.ts` because it is a
  value rather than a type, and consumers outside the badge match on it without wanting the util.
*/
export enum AttachmentKind {
  DOCUMENT = 'document',
  IMAGE = 'image',
  OTHER = 'other',
  PDF = 'pdf',
  TEXT = 'text',
}
